import { type FC } from "react";
import * as styles from "./styles.css";
import { Item, type DefinitionListItemProps } from "./uiParts/Item";

type Props = {
  /** 定義リストのアイテムの配列 */
  items: DefinitionListItemProps[];
  /** タイトル */
  title?: string;
  /** コンポーネントに適用するクラス名 */
  className?: string;
  elementRef?: React.RefObject<HTMLDivElement> | null;
};

export const DefinitionList: FC<Props> = ({ items, title, className, elementRef }) => (
  <div className={title && `${styles.container} ${className || ""}`} ref={elementRef}>
    {title && <p className={styles.title}>{title}</p>}
    <div className={styles.list}>
      {items.map(({ term, description, className: itemClassName }, index) => (
        <Item
          term={term}
          description={description}
          // eslint-disable-next-line react/no-array-index-key, @typescript-eslint/no-base-to-string -- term/description(ReactNode) の文字列表現は key の一意化補助にのみ使用する
          key={`${term}${description}_${index}`}
          className={itemClassName}
        />
      ))}
    </div>
  </div>
);
